/**
 * technology-list
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_seed-technologies-list.css';
import './_seed-technologies-list.twig';

// Testimonial list uses slick slider for the desktop and mobile displays.
require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

export const name = 'seed-technologies-list';

export const defaults = {
  dummyClass: 'js-seed-technologies-list-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { technologyList = {} }) {
  // Find our component within the DOM
  // eslint-disable-next-line no-undef
  const technologyLists = once(
    'seed-technologies-list--init',
    '.seed-technologies-list',
    $context
  );
  // Bail if component does not exist
  if (!technologyLists.length) {
    return;
  }
  const $technologyList = $(technologyLists);
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...technologyList,
  };
  // An example of what could be done with this component
  $technologyList.addClass(settings.dummyClass);

  // Adds slick slider functionality.
  $technologyList
    .filter('.seed-technologies-list--carousel')
    .each(function initializeSlickSlider() {
      $('.seed-technologies-list__items', this).slick({
        arrows: true,
        appendArrows: $(this).find('.seed-technologies-list__actions'),
        centerPadding: '24px',
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 540,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
}

export default enable;
